import { AAGUID } from '@interticket/core';
import { AuditoriumBase } from './auditorium-base.model';
import { Address } from '../address/address.model';
import { IAuditorium } from '@core/interfaces/auditorium/auditorium.interface';

export class Auditorium extends AuditoriumBase implements IAuditorium {

  readonly id: AAGUID;
  readonly isDeleted: boolean;
  readonly venueName: string;
  readonly venueId: AAGUID;
  readonly venueAddress: Address;
  readonly partnerId: AAGUID;

  constructor(iAuditorium: IAuditorium) {
    super(iAuditorium);
    this.id = iAuditorium.id;
    this.isDeleted = iAuditorium.isDeleted;
    this.venueName = iAuditorium.venueName;
    this.venueId = iAuditorium.venueId;
    this.venueAddress = iAuditorium.venueAddress ? new Address(iAuditorium.venueAddress) : null;
    this.partnerId = iAuditorium.partnerId || null;
  }

}
